var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIpoweredicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 63,
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3019_12113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 4.48438H4V32.1034L24 50.5161L44 32.1034V4.48438Z",
    fill: "url(#paint0_linear_3019_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 4.48438H4V32.1034L24 50.5161L44 32.1034V4.48438Z",
    stroke: "url(#paint1_linear_3019_12113)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.855 26.748H18.0517L17.2817 29.0214H14L18.6567 16.1514H22.2867L26.9433 29.0214H23.625L22.855 26.748ZM22.0483 24.328L20.4533 19.6164L18.8767 24.328H22.0483Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4956 16.1514V29.0214H28.3606V16.1514H31.4956Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3019_12113",
    x: 0.5,
    y: 0.984375,
    width: 55,
    height: 61.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3019_12113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3019_12113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3019_12113",
    x1: 4,
    y1: 4.48437,
    x2: 44.8333,
    y2: 51.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0719243,
    stopColor: "#E96358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4030B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3019_12113",
    x1: 4,
    y1: 4.48438,
    x2: 43.1667,
    y2: 50.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105539,
    stopColor: "#FF171D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96358"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIpoweredicon);
export default __webpack_public_path__ + "static/media/AI powered icon.471fa5a3abee60f1164d6b935d1cd4be.svg";
export { ForwardRef as ReactComponent };